module.exports = __webpack_public_path__ + "img/backgroundSelectCity.e940f192.jpg";